module.exports = __webpack_public_path__ + "img/img_title_prize.28e7d2c1.png";